import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hide-inactive-providers"
// Toggles visibility of inactive provider cards in search results
export default class extends Controller {
  static targets = ["providerCard", "banner", "bannerText", "hideLink", "showLink"]

  // Lazily loaded result chunks connect their cards after the initial render;
  // apply the current toggle so they arrive with the right visibility.
  providerCardTargetConnected(card) {
    if (this.hidingInactives && card.dataset.likelyActive !== "true") {
      card.style.display = "none"
    }
  }

  hide(event) {
    event.preventDefault()
    this.hidingInactives = true
    this.providerCardTargets.forEach(card => {
      if (card.dataset.likelyActive !== "true") {
        card.style.display = "none"
      }
    })
    this.bannerTextTarget.textContent = "Hiding inactive providers."
    this.hideLinkTarget.classList.add("hidden")
    this.showLinkTarget.classList.remove("hidden")
  }

  show(event) {
    event.preventDefault()
    this.hidingInactives = false
    this.providerCardTargets.forEach(card => {
      card.style.display = ""
    })
    this.bannerTextTarget.textContent = "Showing all matching providers, even if inactive."
    this.showLinkTarget.classList.add("hidden")
    this.hideLinkTarget.classList.remove("hidden")
  }
}
